import { render, staticRenderFns } from "./carga.vue?vue&type=template&id=30b628bb&scoped=true&"
import script from "./carga.vue?vue&type=script&lang=ts&"
export * from "./carga.vue?vue&type=script&lang=ts&"
import style0 from "./carga.vue?vue&type=style&index=0&id=30b628bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b628bb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
